var map = {
	"./CN-flag.svg": "9ec0",
	"./MA-flag.svg": "81a2",
	"./TH-flag.svg": "46be",
	"./TW-flag.svg": "4d2e",
	"./VN-flag.svg": "a449",
	"./detail-1.png": "adda",
	"./detail-2.png": "180f",
	"./detail-3.png": "69a4",
	"./detail-4.png": "f7f9",
	"./facebook.svg": "3a88",
	"./facebook_blue.svg": "eb5c",
	"./img-work_detail.png": "db47",
	"./img-work_detail_10.png": "72b0",
	"./img-work_detail_2.png": "11bf",
	"./img-work_detail_9.png": "22af",
	"./img-works_1.png": "fd4e",
	"./img-works_5.png": "4ed0",
	"./img-works_6.png": "f110",
	"./img-works_7.png": "8b83",
	"./img-works_9.png": "3f6a",
	"./japan-flag.svg": "2e02",
	"./logo-1.svg": "3dfb",
	"./logo-10.png": "1baa",
	"./logo-2.png": "8b76",
	"./logo-2.svg": "1938",
	"./logo-3.png": "3f18",
	"./logo-3.svg": "69ba",
	"./logo-4.png": "b5de",
	"./logo-4.svg": "66be",
	"./logo-5.svg": "93d6",
	"./logo-6.png": "888d",
	"./logo-6.svg": "b2d1",
	"./logo-7.png": "f083",
	"./logo-7.svg": "f8ab",
	"./logo-8.svg": "7cf0",
	"./logo-9.png": "6689",
	"./logo-9.svg": "f257",
	"./logo-company.svg": "4ccb",
	"./logo-company_10.png": "fd2a",
	"./logo-company_3.png": "5b93",
	"./logo-company_4.png": "1938d",
	"./logo-company_7.png": "b659",
	"./logo-company_9.png": "d0e7",
	"./logo-meiji.svg": "6d87",
	"./singapore-flag.svg": "4b6e",
	"./twitter.svg": "5461",
	"./twitter_blue.svg": "e595",
	"./work-1.png": "d8ab",
	"./work-10.png": "c5dc",
	"./work-2.png": "06e7",
	"./work-3.png": "51e4",
	"./work-4.png": "7dcb",
	"./work-5.png": "c83e",
	"./work-6.png": "5374",
	"./work-7.png": "7652",
	"./work-8.png": "cc21",
	"./work-9.png": "660f",
	"./works-detail_3.png": "08d5",
	"./works-detail_6.png": "c629"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47e3";